import React from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  Button,
  Box,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { useNavigate } from "react-router-dom";

export default function SuccessDialog({ open, onClose }) {
  const navigate = useNavigate();

  const handleOk = () => {
  
    navigate("/cst_rooster"); // ✅ change path if needed
  };

  return (
    <Dialog
      open={true}
     
      PaperProps={{
        sx: {
          overflow: "visible",
          borderRadius: 3,
          textAlign: "center",
          px: 2,
          pb: 4,
          pt: 6,
        },
      }}
    >
      {/* ✅ Circle with tick */}
      <Box
        sx={{
          position: "absolute",
          top: -40,
          left: "50%",
          transform: "translateX(-50%)",
          width: 80,
          height: 80,
          borderRadius: "50%",
          bgcolor: "green",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: 3,
        }}
      >
        <CheckIcon sx={{ fontSize: 50, color: "white" }} />
      </Box>

      {/* Body */}
      <DialogContent>
        <DialogTitle sx={{ fontWeight: "bold" }}>Successfully</DialogTitle>
        <Typography>Roster Created Successfully</Typography>
      </DialogContent>

      <Box>
        <Button
          variant="contained"
          color="success"
          onClick={handleOk}
          sx={{ borderRadius: 2, px: 4, width: "100%" }}
        >
          OK
        </Button>
      </Box>
    </Dialog>
  );
}
